const RETENTION_MONTHS = 5;
const SCHEDULED_DELETION_DAY = 23;

const DATE_FORMAT_OPTIONS: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "numeric",
  year: "numeric",
  timeZone: "UTC",
};

function getDeletionDate(uploadedAt: Date): Date {
  const year = uploadedAt.getUTCFullYear();
  const month = uploadedAt.getUTCMonth() + RETENTION_MONTHS;
  const day = uploadedAt.getUTCDate();

  const targetMonth = day > SCHEDULED_DELETION_DAY ? month + 1 : month;
  return new Date(Date.UTC(year, targetMonth, SCHEDULED_DELETION_DAY));
}

export function computeDeletionDate(uploadedAt: Date | undefined): string {
  if (!uploadedAt) return "";
  return getDeletionDate(uploadedAt).toLocaleDateString(
    "en-US",
    DATE_FORMAT_OPTIONS,
  );
}

export function isDeletionDatePast(uploadedAt: Date): boolean {
  return getDeletionDate(uploadedAt) < new Date();
}

export function getDisplayDeletionDate(uploadedAt: Date): Date {
  if (isDeletionDatePast(uploadedAt)) {
    const today = new Date();

    return new Date(today.getFullYear(), today.getMonth(), today.getDate());
  }

  const deletionDate = getDeletionDate(uploadedAt);

  return new Date(
    deletionDate.getUTCFullYear(),
    deletionDate.getUTCMonth(),
    deletionDate.getUTCDate(),
  );
}
